export default "__VITE_ASSET__Cgs2yi$Q__"